import http from './http'

export default {
  billQuery: {
    getBillPamentPageList (search, pageConfig) {
      return http.get('/sale/billquery/getbillpamentpagelist', {
        shopId: search.shop,
        date: search.date,
        payType: search.payType,
        stallId: search.stallId,
        merchantId: search.merchantId,
        deviceCode: search.deviceCode,
        memberCardCode: search.memberCardCode,
        code: search.code,
        isReturn: search.isReturn,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getBillSalePageList (search, pageConfig) {
      return http.get('/sale/billquery/getbillsalepagelist', {
        shopId: search.shop,
        date: search.date,
        product: search.product,
        stallId: search.stallId,
        merchantId: search.merchantId,
        deviceCode: search.deviceCode,
        code: search.code,
        isReturn: search.isReturn,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getBillSaleACPageList (search, pageConfig) {
      return http.get('/sale/billquery/getbillsaleacpagelist', {
        shopId: search.shop,
        date: search.date,
        product: search.product,
        stallId: search.stallId,
        merchantId: search.merchantId,
        deviceCode: search.deviceCode,
        code: search.code,
        isReturn: search.isReturn,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    }
  },
  demandNote: {
    getShopDifferencePageList (search, pageConfig) {
      return http.get('/sale/demandnote/getshopdifferencepagelist', {
        shopId: search.shop,
        startDate: search.startDate,
        endDate: search.endDate,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getOperaterDifferencePageList (search, pageConfig) {
      return http.get('/sale/demandnote/getoperaterdifferencepagelist', {
        shopId: search.shop,
        startDate: search.startDate,
        endDate: search.endDate,
        userId: search.user,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/sale.js